module.exports = "<div class=\"card\">\r\n  <div class=\"card-body\">\r\n    <spk-search-grid #grid [list]=\"'CommandSecurityRoleSearchRow'\" title=\"Security Checkpoints\" autoload=\"true\" defaultSortProperty=\"CommandName, Role\" showSearch=\"true\"\r\n      [leftLinks]=\"leftLinks\" [csvExport]=\"true\">\r\n    </spk-search-grid>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/security/checkpoints/checkpoints.component.html
// module id = ./src/app/components/security/checkpoints/checkpoints.component.html
// module chunks = main